import { PropsWithChildren } from 'react';

import { MobileMenuBottomLinks } from '../BottomLinks/MobileMenuBottomLinks';

import { MobileMenuTitle } from './MobileMenuTitle/MobileMenuTitle';
import style from './MobileView.module.css';
import { MobileViewSeparator } from './Separator/MobileViewSeparator';

export function MobileView({
    title,
    children,
    beforeTitleSlot,
}: PropsWithChildren<{ title: string | null; beforeTitleSlot?: React.ReactNode }>) {
    return (
        <div className={style.mobileView}>
            {beforeTitleSlot ? beforeTitleSlot : null}
            {title ? <MobileMenuTitle title={title} /> : null}
            {children}
            <MobileViewSeparator />
            <MobileMenuBottomLinks />
        </div>
    );
}
